import { render, staticRenderFns } from "./UrlCreate.vue?vue&type=template&id=502a6869&scoped=true"
import script from "./UrlCreate.vue?vue&type=script&lang=js"
export * from "./UrlCreate.vue?vue&type=script&lang=js"
import style0 from "./UrlCreate.vue?vue&type=style&index=0&id=502a6869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502a6869",
  null
  
)

export default component.exports